import { render, staticRenderFns } from "./VLeadDetails.vue?vue&type=template&id=6a721efa"
import script from "./VLeadDetails.vue?vue&type=script&lang=js"
export * from "./VLeadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports